export enum MotorDriveConnection {
    WithGearbox,
    Direct
}
